'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TransmuteCollection = require('./TransmuteCollection');

_TransmuteCollection.set.implement(Array, function (index, value, arr) {
  if ((0, _immutable.is)(arr[index], value)) {
    return arr;
  }
  var next = arr.concat();
  next.splice(index, 1, value);
  return next;
});

_TransmuteCollection.set.implementInherited(_immutable.Iterable, function (key, value, subject) {
  return subject.set(key, value);
});

_TransmuteCollection.set.implement(Object, function (key, value, obj) {
  if ((0, _immutable.is)(obj[key], value)) {
    return obj;
  }
  var result = Object.assign({}, obj);
  result[key] = value;
  return result;
});

exports.default = _TransmuteCollection.set;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_set.js
// module id = 60
// module chunks = 0 1